import { Typography } from '@mui/material';
import type { SvgIconProps } from '@mui/material';
import Android from '@mui/icons-material/Android';
import Apple from '@mui/icons-material/Apple';
import DesktopWindows from '@mui/icons-material/DesktopWindows';
import { styled } from '@mui/material/styles';

export type PlatformIconProps = {
  label?: string;
  platform: 'ios' | 'android' | 'web';
  iconProps?: SvgIconProps;
};

const Container = styled('div')({
  display: 'flex',
  gap: '9px',
  alignItems: 'center',
  padding: '5px 12px 5px 5px',
});

const platformIconSelector = {
  ios: Apple,
  android: Android,
  web: DesktopWindows,
};

/**
 * PlatformIcon component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {PlatformIconProps} platformIconProps - The props for the PlatformIcon component
 * @returns {ReactElement} The PlatformIcon component
 */

export const PlatformIcon = (props: PlatformIconProps) => {
  const { label, platform, iconProps } = props;
  const IconComponent = platformIconSelector[platform];
  return (
    <>
      <Container>
        <IconComponent fontSize="small" color="primary" {...iconProps} />
        {label && label.length > 0 && (
          <Typography variant="body2">{label}</Typography>
        )}
      </Container>
    </>
  );
};
